import React from 'react'
import './Live.css'

function Live() {
    return (
        <div className='live'>
            <h1>Go Live</h1>
             <h5>Coming soon</h5>
        </div>
    )
}

export default Live
